<button
  class="btn gradient"
  type="button"
  [disabled]="isDisabled">
  <label>{{ label }}</label>
</button>
